module.exports = __webpack_public_path__ + "img/hr-brown-hairy-grass-13.6acb6022.png";